import { isWeb, useGetAverageReviewsForApplicationQuery } from "@stepapp/core";
import { Block, palette, SvgIcon, spacing, Typography, useBreakpoints } from "@stepapp/ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { ScrollView, StyleSheet } from "react-native";

const FeaturesList = () => {
  const { t } = useTranslation();
  const { mobileOnly, xl } = useBreakpoints();

  const cardHeight = mobileOnly ? 8 : 10;
  const cardWidth = xl ? "100%" : undefined;
  const cardMaxWidth = xl ? 33 : undefined;

  const { data } = useGetAverageReviewsForApplicationQuery();

  const reviewsNumber = data?.getAverageReviewsForApplication.total || 17920;
  const avgRating = data?.getAverageReviewsForApplication.average?.toFixed(2) || 4.97;

  const items = [
    {
      label: t("screens.dashboard.trainedProfessionals"),
      icon: "certificate2",
    },
    {
      label: t("screens.dashboard.secureOnlineBooking"),
      icon: "calendar-heart",
    },
    {
      label: t("screens.dashboard.liabilityInsurance"),
      icon: "shield",
    },
    {
      label: t("screens.dashboard.reviewsWithRating", {
        reviews: reviewsNumber,
        rating: avgRating,
      }),
      icon: "trophy",
    },
  ] as const;

  return (
    <Block>
      <ScrollView horizontal contentContainerStyle={styles.container}>
        {items.map((item) => (
          <Block
            row
            key={item.label}
            height={cardHeight}
            width={cardWidth}
            maxWidth={cardMaxWidth}
            style={styles.card}
          >
            <SvgIcon name={item.icon} size={20} style={styles.icon} color={palette.primary.green} />
            <Typography variant="paragraph" style={styles.text}>
              {item.label}
            </Typography>
          </Block>
        ))}
      </ScrollView>
    </Block>
  );
};

export default React.memo(FeaturesList);

const styles = StyleSheet.create({
  container: {
    marginBottom: spacing.unit * 2,
    flexDirection: "row",
    justifyContent: "space-between",
    flex: isWeb ? 1 : undefined,
    gap: spacing.unit * 2,
  },
  card: {
    alignItems: "center",
    borderRadius: spacing.radius,
    paddingLeft: spacing.unit * 2.5,
    borderColor: palette.common.mediumGray,
    borderWidth: 1,
  },
  icon: {
    marginRight: spacing.unit * 2,
  },
  text: {
    maxWidth: spacing.unit * 22,
  },
});
